import { Box, Flex } from '@chakra-ui/react';
import PageContainer from 'components/PageContainer';
import { motion } from 'framer-motion';
import useDownloadAppHandler from 'hooks/useDownloadAppHandler';
import React from 'react';
import DownloadAppBannerContent from './DownloadAppBannerContent';

const DownloadAppBannerDesktopRedirectQr = () => {
  const downloadAppHandler = useDownloadAppHandler();

  return (
    <Box
      as={motion.div}
      px={5}
      py={4}
      position="fixed"
      bottom="0"
      width="100%"
      zIndex={99}
      background="black"
      transition="opacity 0.5s ease, padding 0.1s ease"
      initial={{
        opacity: 0
      }}
      animate={{
        opacity: 1
      }}
    >
      <PageContainer>
        <Flex justifyContent="space-between" alignItems="center" width="100%">
          <DownloadAppBannerContent onClick={downloadAppHandler} />
        </Flex>
      </PageContainer>
    </Box>
  );
};

export default DownloadAppBannerDesktopRedirectQr;
